function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenwallslogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "25px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,64.705884%,31.764707%)",
      fillOpacity: 1
    },
    d: "M 10.679688 10.363281 L 24 23.953125 L 10.679688 23.953125 Z M 10.679688 10.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,68.235296%,93.725491%)",
      fillOpacity: 1
    },
    d: "M 23.539062 2.257812 C 21.210938 0.824219 18.496094 0 15.59375 0 C 6.980469 0 0 7.25 0 16.191406 C 0 19.023438 0.699219 21.683594 1.929688 24 L 7.316406 24 C 5.554688 21.9375 4.484375 19.21875 4.484375 16.246094 C 4.484375 9.785156 9.53125 4.546875 15.753906 4.546875 C 17.835938 4.546875 19.785156 5.132812 21.457031 6.15625 Z M 23.539062 2.257812 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenwallslogo);
export default __webpack_public_path__ + "static/media/greenwallslogo.c3c3754edb6cd024f33fba9977864705.svg";
export { ForwardRef as ReactComponent };